import React from "react";
import { AbsoluteFill, useCurrentFrame } from "remotion";

/**
 * Procedural Film Grain Overlay from Remotion 3D and Cinematic
 * Uses SVG feTurbulence with animated seed to unify colors and eliminate plastic digital look.
 */
export const FilmGrain: React.FC<{ opacity?: number }> = ({ opacity = 0.045 }) => {
  const frame = useCurrentFrame();
  const seed = frame % 10;

  return (
    <AbsoluteFill
      style={{
        pointerEvents: "none",
        opacity,
        mixBlendMode: "overlay",
        zIndex: 90,
      }}
    >
      <svg width="100%" height="100%">
        <filter id="grain-filter">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.8"
            numOctaves={3}
            seed={seed}
            stitchTiles="stitch"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#grain-filter)" />
      </svg>
    </AbsoluteFill>
  );
};
